import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';

import { meActions } from './actions';
import {
  VERIFY_FAILURE,
  VERIFY_REQUEST,
  REFRESH_WALLET_FAILURE,
  REFRESH_WALLET_SUCCESS,
  REFRESH_WALLET_REQUEST,
  USER_PREMIUM_PLANS_FAILURE,
  USER_PREMIUM_PLANS_SUCCESS,
  USER_PREMIUM_PLANS_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RECOVER_PASSWORD_SUCCESS,
  RECOVER_PASSWORD_FAILURE,
  RECOVER_PASSWORD_REQUEST,
} from '../../constants/me';

export type MeState = {
  readonly verifyToken?: any;
  readonly isVerifyLoading?: any;
  readonly isVerifyErroring?: any;
  readonly isWalletLoading?: boolean;
  readonly isResetPasswordLoading?: any;
  readonly isResetPasswordErroring?: any;
  readonly didResetPasswordSucceed?: any;
  readonly isRecoverPasswordLoading?: any;
  readonly isRecoverPasswordErroring?: any;
  readonly didRecoverPasswordSucceed?: any;
  readonly wallet?: any;
  readonly userPremiumPlans?: any;
  readonly resetPassword?: any;
  readonly recoverPassword?: any;
  readonly isLoading?: boolean;
};
export type MeActions = ActionType<typeof meActions>;

export const meReducer = combineReducers<MeState, MeActions>({
  isWalletLoading: (state = true, action) => {
    switch (action.type) {
      case REFRESH_WALLET_SUCCESS:
        return false;
      case REFRESH_WALLET_FAILURE:
        return false;
      case REFRESH_WALLET_REQUEST:
        return true;
      default:
        return state;
    }
  },
  isVerifyLoading: (state = false, action) => {
    return action.type === VERIFY_REQUEST;
  },
  isVerifyErroring: (state = null, action) => {
    if (action.type === VERIFY_FAILURE) {
      return action.payload.message || action.payload.detail;
    } else {
      return state;
    }
  },

  wallet: (state = null, action) => {
    if (action.type === REFRESH_WALLET_SUCCESS) {
      return action.payload;
    } else {
      return state;
    }
  },
  isLoading: (state = false, action) => {
    if (action.type === USER_PREMIUM_PLANS_REQUEST) {
      return true;
    } else if (
      action.type === USER_PREMIUM_PLANS_SUCCESS ||
      action.type === USER_PREMIUM_PLANS_FAILURE
    ) {
      return false;
    } else {
      return state;
    }
  },
  userPremiumPlans: (state = null, action) => {
    if (action.type === USER_PREMIUM_PLANS_SUCCESS) {
      return action.payload;
    } else {
      return state;
    }
  },

  isResetPasswordLoading: (state = false, action) => {
    switch (action.type) {
      case RESET_PASSWORD_REQUEST:
        return true;
      case RESET_PASSWORD_SUCCESS:
      case RESET_PASSWORD_FAILURE:
        return false;
      default:
        return state;
    }
  },
  isResetPasswordErroring: (state = null, action) => {
    if (action.type === RESET_PASSWORD_FAILURE) {
      return action.payload.message || action.payload.detail;
    } else {
      return state;
    }
  },
  didResetPasswordSucceed: (state = false, action) => {
    if (action.type === RESET_PASSWORD_SUCCESS) {
      return true;
    } else {
      return state;
    }
  },
  isRecoverPasswordLoading: (state = false, action) => {
    switch (action.type) {
      case RECOVER_PASSWORD_REQUEST:
        return true;
      case RECOVER_PASSWORD_SUCCESS:
      case RECOVER_PASSWORD_FAILURE:
        return false;
      default:
        return state;
    }
  },
  isRecoverPasswordErroring: (state = null, action) => {
    if (action.type === RECOVER_PASSWORD_FAILURE) {
      return action.payload.message || action.payload.detail;
    } else {
      return state;
    }
  },
  didRecoverPasswordSucceed: (state = false, action) => {
    if (action.type === RECOVER_PASSWORD_SUCCESS) {
      return true;
    } else {
      return false;
    }
  },
});
